<div class="calibration-details-container" [class.print-mode]="isPrintMode">
    <div class="calibration-details-body">
        <div class="calibration-details-scroll bpx-report" #calibrationDetailsScroll>
    <!--
      The print route keeps the plain stacked run-out of labels it has always printed; on screen the
      same five values read as an identification card, matching the other tabs.
    -->
    @if (isPrintView) {
    <app-print-preview-bar
        viewName="Calibration Details"
        [studyName]="selectedStudy?.studyName ?? ''"
        [contextLine]="printContextLine"
        [tableColumns]="tableColumns"
        (selectColumns)="handlePrintColumnSelection($event)"></app-print-preview-bar>

    <div class="bpx-detail cal-details-meta bpx-screen-only">
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Panel Name</span>
            <span class="bpx-detail__value">{{ (panelName$ | async) }}</span>
        </div>
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Run Type</span>
            <span class="bpx-detail__value">{{ selectedStudy?.runType }}</span>
        </div>
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Test Spec</span>
            <span class="bpx-detail__value">{{ selectedStudy?.testSpec }}</span>
        </div>
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Assignment Spec</span>
            <span class="bpx-detail__value">Final</span>
        </div>
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Operator</span>
            <span class="bpx-detail__value">{{ operatorName || '-' }}</span>
        </div>
    </div>

    <div class="bpx-print-only">
    <br />
    Panel Name: <span id="panel-name">{{ (panelName$ | async) }}</span><br />
    Run Type: <span id="run-type">{{ selectedStudy?.runType }}</span><br />
    Test Spec: <span id="test-spec">{{ selectedStudy?.testSpec }}</span><br />
    Assignment Spec: <span id="assignment-spec">Final</span><br />
    Operator: <span id="operator">{{ operatorName || '-' }}</span><br /><br />
    </div>
    } @else {
    <div class="bpx-detail cal-details-meta">
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Panel Name</span>
            <span class="bpx-detail__value" id="panel-name">{{ (panelName$ | async) }}</span>
        </div>
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Run Type</span>
            <span class="bpx-detail__value" id="run-type">{{ selectedStudy?.runType }}</span>
        </div>
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Test Spec</span>
            <span class="bpx-detail__value" id="test-spec">{{ selectedStudy?.testSpec }}</span>
        </div>
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Assignment Spec</span>
            <span class="bpx-detail__value" id="assignment-spec">Final</span>
        </div>
        <div class="bpx-detail__item">
            <span class="bpx-detail__label">Operator</span>
            <span class="bpx-detail__value" id="operator">{{ operatorName || '-' }}</span>
        </div>
    </div>

    <div class="bpx-toolbar__actions cal-details-actions">
        <a (click)="toggleAllSections(true)" class="bpx-btn">Expand All Sections</a>
        <a (click)="toggleAllSections(false)" class="bpx-btn">Collapse All Sections</a>
        <span class="bpx-toolbar__sep" aria-hidden="true"></span>
        <a (click)="exportToCsv()" class="bpx-btn"
      [class.bpx-btn--disabled]="!calResponseCombinedData.length"
      [attr.aria-disabled]="!calResponseCombinedData.length"
      [style.pointer-events]="!calResponseCombinedData.length ? 'none' : null">
            <mat-icon fontIcon="download"></mat-icon>Export
        </a>
        <a (click)="navigateToPrintView()" class="bpx-btn"
      [class.bpx-btn--disabled]="(isStudySaved$ | async) !== true"
      [attr.aria-disabled]="(isStudySaved$ | async) !== true"
      [style.pointer-events]="((isStudySaved$ | async) !== true) ? 'none' : null">
            <mat-icon fontIcon="print"></mat-icon>Print View
        </a>
    </div>
    }
    @if (isPrintView && isPrintMode) {
    @for (pageColumns of printPages; track trackByPage; let pageIndex = $index) {
    <div class="bpx-print-page" [class.bpx-print-page--last]="pageIndex === (printPages.length - 1)">
      @if (printPageCaption(pageIndex)) {
      <div class="bpx-print-page-caption">{{ printPageCaption(pageIndex) }}</div>
      }
      <div class="calibration-page-header" aria-hidden="true">
        Bio-Rad Laboratories<br />
        Redmond, WA
      </div>
      <ng-container *ngTemplateOutlet="calibrationTable; context: { pageColumns: pageColumns, tableId: (pageIndex === 0 ? 'calibrator-table' : null) }"></ng-container>
    </div>
    }
    } @else {
      <ng-container *ngTemplateOutlet="calibrationTable; context: { pageColumns: calResponseCombinedData, tableId: 'calibrator-table' }"></ng-container>
    }

    <ng-template #calibrationTable let-pageColumns="pageColumns" let-tableId="tableId">
    <table #calibrationDetailsTable [attr.id]="tableId"
        class="bpx-report__table bpx-report__table--pin-first bpx-report__table--sticky-head calibration-details__table"
        [class.calibrator-assay-print]="isPrintMode" matTableExporter #exporter="matTableExporter">    
        <thead class="bpx-report__head">
            @if (rowHasAnyReportContentValue('lot')) {
            <tr>
                <td class="!align-middle">KitLot#</td>
                <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;"
                    class="mt-6">
                    <td class="!align-middle" [ngClass]="{ 'selected-kit-highlight' : (selectedStudy?.refKitLot !=='' && reportContentItem?.reportContentItems?.lot === selectedStudy?.refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
                        {{ displayDash(reportContentItem.reportContentItems.lot) }}
                        <ng-container *ngIf="reportContentItem.valueAssigned === 'AdjustedCalculate'">
                            <span class="block">{{ adjustedLabel }}</span>
                        </ng-container>
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyReportContentValue('runId')) {
            <tr>
                <td>Instrument ID</td>
                <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;"
                    class="mt-6">
                    <td [ngClass]="{ 'selected-kit-highlight' : (selectedStudy?.refKitLot !=='' && reportContentItem?.reportContentItems?.lot === selectedStudy?.refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
                        {{ displayDash(reportContentItem.reportContentItems.runId) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyReportContentValue('assay')) {
            <tr>
                <td>Assay Name</td>
                <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;"
                    class="mt-6">
                    <td [ngClass]="{ 'selected-kit-highlight' : (selectedStudy?.refKitLot !=='' && reportContentItem?.reportContentItems?.lot === selectedStudy?.refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
                        {{ displayDash(reportContentItem.reportContentItems.assay) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyReportContentValue('region')) {
            <tr>
                <td>Bead Region</td>
                <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;"
                    class="mt-6">
                    <td [ngClass]="{ 'selected-kit-highlight' : (selectedStudy?.refKitLot !=='' && reportContentItem?.reportContentItems?.lot === selectedStudy?.refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
                        {{ displayDash(reportContentItem.reportContentItems.region) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyReportContentValue('units')) {
            <tr>
                <td>Units</td>
                <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;"
                    class="mt-6">
                    <td [ngClass]="{ 'selected-kit-highlight' : (selectedStudy?.refKitLot !=='' && reportContentItem?.reportContentItems?.lot === selectedStudy?.refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
                        {{ displayDash(reportContentItem.reportContentItems.units) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyReportContentValue('resultDecimalPrecision')) {
            <tr>
                <td>Result Decimal Precision</td>
                <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;"
                    class="mt-6">
                    <td [ngClass]="{ 'selected-kit-highlight' : (selectedStudy?.refKitLot !=='' && reportContentItem?.reportContentItems?.lot === selectedStudy?.refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
                        {{ displayDash(reportContentItem.reportContentItems.resultDecimalPrecision) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyReportContentValue('userDefinedDecimalPrecision')) {
            <tr>
                <td>User Defined Decimal Precision</td>
                <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;"
                    class="mt-6">
                    <td [ngClass]="{ 'selected-kit-highlight' : (selectedStudy?.refKitLot !=='' && reportContentItem?.reportContentItems?.lot === selectedStudy?.refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
                        {{ displayDash(reportContentItem.reportContentItems.userDefinedDecimalPrecision) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyReportContentValue('resultType')) {
            <tr>
                <td>Result Type</td>
                <ng-container *ngFor="let reportContentItem of pageColumns; trackBy: trackByFn;"
                    class="mt-6">
                    <td [ngClass]="{ 'selected-kit-highlight' : (selectedStudy?.refKitLot !=='' && reportContentItem?.reportContentItems?.lot === selectedStudy?.refKitLot),
              'adjusted-column-highlight': !isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate', 'final-column-highlight': isFinal && reportContentItem.valueAssigned === 'AdjustedCalculate'}">
                        {{ displayDash(reportContentItem.reportContentItems.resultType) }}
                    </td>
                </ng-container>
            </tr>
            }
        </thead>
        <tbody>

            @if(isPrintMode) {
            <tr class="subsection-header-print">
                <td>
                    Calibration Curve
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(0)" title="Click to show/hide section">
                <td class="collapsed-section-header collapsed-section-label">
                    Calibration Curve
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)"></td>
            </tr>
            }
            @if(sectionVisibility[0]) {
            @if (rowHasAnyCalibrationCurveValue('assay_range_lower')) {
            <tr>
                <td>Low Assay Range</td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td>
                        {{ displayDash(materialItem?.calibrationCurve?.assay_range_lower) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyCalibrationCurveValue('assay_range_upper')) {
            <tr>
                <td>High Assay Range</td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td>
                        {{ displayDash(materialItem?.calibrationCurve?.assay_range_upper) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyCalibrationCurveValue('cut_off')) {
            <tr>
                <td>Assay Cut-Off</td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td>
                        {{ displayDash(materialItem?.calibrationCurve?.cut_off) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyCalibrationCurveValue('result_decimal_precision')) {
            <tr>
                <td>Result Decimal Precision</td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td>
                        {{ displayDash(materialItem?.calibrationCurve?.result_decimal_precision) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyCalibrationCurveValue('math_model')) {
            <tr>
                <td>Math Model</td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td>
                        {{ displayDash(materialItem?.calibrationCurve?.math_model) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyCalibrationCurveValue('curve_direction')) {
            <tr>
                <td>Curve Direction</td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td>
                        {{ displayDash(materialItem?.calibrationCurve?.curve_direction) }}
                    </td>
                </ng-container>
            </tr>
            }
            @if (rowHasAnyCalibrationCurveValue('monotonic')) {
            <tr>
                <td>Monotonic Pass/Fail</td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td>
                        <span
                            [ngClass]="getStatusClassFromResult(materialItem?.calibrationCurve?.monotonic)">
                            {{ displayDash(materialItem?.calibrationCurve?.monotonic) | uppercase }}
                        </span>
                    </td>
                </ng-container>
            </tr>
            }
            }

            @if(isPrintMode) {
            <tr class="subsection-header-print-firstrow">
                <td>
                    Calibrator Vial
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(1)" title="Click to show/hide section">
                <td class="collapsed-section-header collapsed-section-label">
                    Calibrator Vial
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)"></td>
            </tr>
            }
            @if(sectionVisibility[1]) {
            <ng-container *ngFor="let row of noOfRows">
                <tr *ngIf="rowHasAnyCalibratorValue(row, 'index')">
                    <td> {{row}} </td>
                    <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                        <td>{{ getCalibratorValue(row, materialItem, 'index') }}</td>
                    </ng-container>
                </tr>
            </ng-container>
            }


            @if(isPrintMode) {
            <tr class="subsection-header-print">
                <td>
                    Calibrator Assignment
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(2)" title="Click to show/hide section">
                <td class="collapsed-section-header collapsed-section-label">
                    Calibrator Assignment
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)"></td>
            </tr>
            }
            @if(sectionVisibility[2]) {
            <ng-container *ngFor="let row of noOfRows">
                <tr *ngIf="rowHasAnyCalibratorValue(row, 'originalAssignment') || rowHasAnyCalibratorValue(row, 'optimizedAssignment')">
                    <td> {{row}} </td>
                    <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                        <td>{{ getCalibratorValue(row, materialItem, materialItem.valueAssigned === 'AdjustedCalculate' && !isFinal ? 'optimizedAssignment' : 'originalAssignment') }}</td>
                    </ng-container>
                </tr>
            </ng-container>
            }


            @if(isPrintMode) {
            <tr class="subsection-header-print">
                <td>
                    Calibrator (Avg RFI)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(3)" title="Click to show/hide section">
                <td class="collapsed-section-header collapsed-section-label">
                    Calibrator (Avg RFI)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)"></td>
            </tr>
            }
            @if(sectionVisibility[3]) {
            <ng-container *ngFor="let row of noOfRows">
                <tr *ngIf="rowHasAnyCalibratorValue(row, 'meanRfi')">
                    <td> {{row}} </td>
                    <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                        <td>{{ getCalibratorValue(row, materialItem, 'meanRfi') }}</td>
                    </ng-container>
                </tr>
            </ng-container>
            }


            @if(isPrintMode) {
            <tr class="subsection-header-print">
                <td>
                    Calibrator (Avg FR)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(4)" title="Click to show/hide section">
                <td class="collapsed-section-header collapsed-section-label">
                    Calibrator (Avg FR)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)"></td>
            </tr>
            }
            @if(sectionVisibility[4]) {
            <ng-container *ngFor="let row of noOfRows">
                <tr *ngIf="rowHasAnyCalibratorValue(row, 'meanFR')">
                    <td> {{row}} </td>
                    <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                        <td>{{ getCalibratorValue(row, materialItem, 'meanFR') }}</td>
                    </ng-container>
                </tr>
            </ng-container>
            }

            @if(isPrintMode) {
            <tr class="subsection-header-print">
                <td>
                    Calibrator (Avg Adjusted FR)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(5)" title="Click to show/hide section">
                <td class="collapsed-section-header collapsed-section-label">
                    Calibrator (Avg Adjusted FR)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)"></td>
            </tr>
            }
            @if(sectionVisibility[5]) {
            <ng-container *ngFor="let row of noOfRows">
                <tr *ngIf="rowHasAnyCalibratorValue(row, 'adjustedFr')">
                    <td> {{row}} </td>
                    <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                        <td>{{ getCalibratorValue(row, materialItem, 'adjustedFr') }}</td>
                    </ng-container>
                </tr>
            </ng-container>
            }

            @if(isPrintMode) {
            <tr class="subsection-header-print">
                <td>
                    Calibrator (Replicate CV)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(6)" title="Click to show/hide section">
                <td class="collapsed-section-header collapsed-section-label">
                    Calibrator (Replicate CV)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)"></td>
            </tr>
            }
            @if(sectionVisibility[6]) {
            <ng-container *ngFor="let row of noOfRows">
                <tr *ngIf="rowHasAnyCalibratorValue(row, 'repRfiCV')">
                    <td> {{row}} </td>
                    <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                        <td>{{ getCalibratorValue(row, materialItem, 'repRfiCV') }}</td>
                    </ng-container>
                </tr>
            </ng-container>
            }

            @if(isPrintMode) {
            <tr class="subsection-header-print">
                <td>
                    Calibrator CV (Pass/Fail)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(7)" title="Click to show/hide section">
                <td class="collapsed-section-header collapsed-section-label">
                    Calibrator CV (Pass/Fail)
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)"></td>
            </tr>
            }
            @if(sectionVisibility[7]) {
            <ng-container *ngFor="let row of noOfRows">
                <tr *ngIf="rowHasAnyCalibratorValue(row, 'repRfiCvOk')">
                    <td> {{row}} </td>
                    <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                        <td>{{ getCalibratorValue(row, materialItem, 'repRfiCvOk') }}</td>
                    </ng-container>
                </tr>
            </ng-container>
            }

            <!--
            @if(isPrintMode) {
            <tr class="subsection-header-print">
                <td>
                    4PL Parameters
                </td>
                <td [attr.colspan]="(pageColumns.length || 0)">
                </td>
            </tr>
            } @else {
            <tr [ngClass]="{ 'subsection-header' : !isPrintMode, 'subsection-header-print2': isPrintMode }"
                (click)="toggleSectionDisplay(8)" title="Click to show/hide section">
                <td [attr.colspan]="(pageColumns.length || 0) + 1" class="collapsed-section-header collapsed-section-label">
                    4PL Parameters
                </td>
            </tr>
            }
            @if(sectionVisibility[8]) {
            <tr *ngFor="let row of noOfRowAlphabet">
                <td> {{row}} </td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td></td>
                </ng-container>
            </tr>
            <tr>
                <td> Residuals (4PL Only) </td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td></td>
                </ng-container>
            </tr>
            <tr *ngFor="let row of noOfRows">
                <td> {{row}} </td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td></td>
                </ng-container>
            </tr>
            <tr>
                <td> Residuals Pass/Fail Spec. (4PL Only) </td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td></td>
                </ng-container>
            </tr>
            <tr *ngFor="let row of noOfRows">
                <td> {{row}} </td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td></td>
                </ng-container>
            </tr>
            <tr>
                <td> Residuals Pass/Fail (4PL Only) </td>
                <ng-container *ngFor="let materialItem of pageColumns; trackBy: trackByFn;" class="mt-6">
                    <td></td>
                </ng-container>
            </tr>
            }
            -->
        </tbody>
        <tfoot class="bpx-print-spacer-footer">
            <tr>
                <td [attr.colspan]="(pageColumns.length || 0) + 1">
                    <div class="bpx-print-footer-spacer" aria-hidden="true"></div>
                </td>
            </tr>
        </tfoot>
    </table>
    </ng-template>
        </div>
    </div>
</div>

@if (isPrintMode) {
<div class="print-footer-cutoff" aria-hidden="true"></div>
<div class="footer">
    <div class="print-footer-left">
        {{ selectedStudy?.studyName || '-' }}<br />
        {{ (panelName$ | async) || '-' }} : Spec Rev {{ selectedStudy?.panelSpecs?.revisionNumber || '-' }}<br />
        Web App Version: {{ appVersion || '-' }}
    </div>
</div>
}
